import { FlexLayout, Spacer } from '@Styled/utilities';
import React, { FC } from 'react';
import { TypedTestQuestion } from '../../Types/TestQuestion';
import { QuestionContentExpanded } from './QuestionAccordion.styled';
import { renderFormulasInHtml } from '@RichTextEditor';

type Props = {
	question: TypedTestQuestion<'essay'>;
};
const EssayAccordion: FC<Props> = ({ question }) => {
	return (
		<FlexLayout flexDirection="column">
			<QuestionContentExpanded>
				<div
					dangerouslySetInnerHTML={{
						__html: renderFormulasInHtml(question.content),
					}}
				/>
			</QuestionContentExpanded>
			<Spacer mb="2rem" />
			<FlexLayout flexDirection="column"></FlexLayout>
		</FlexLayout>
	);
};

export default EssayAccordion;
